import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';

const API = process.env.REACT_APP_API_URL || 'https://api.ctexpresskh.com/api';

export default function NewsFeed() {
  const [feeds, setFeeds] = useState([]);
  const [form, setForm] = useState({ title: '', image_url: '', link_url: '', sort_order: 0 });
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadMode, setUploadMode] = useState('url');
  const fileRef = useRef();

  useEffect(() => { load(); }, []);

  const load = async () => {
    const token = localStorage.getItem('token');
    const res = await fetch(API + '/news', { headers: { Authorization: 'Bearer ' + token } });
    const data = await res.json();
    if (data.success) setFeeds(data.data);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5MB'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => { setForm(f => ({ ...f, image_url: ev.target.result })); };
    reader.readAsDataURL(file);
  };

  const save = async () => {
    if (!form.image_url) { toast.error('Please add an image'); return; }
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const url = editing ? API + '/news/' + editing : API + '/news';
      const method = editing ? 'PUT' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.success) { toast.success(editing ? 'Updated!' : 'Added!'); setForm({ title: '', image_url: '', link_url: '', sort_order: 0 }); setEditing(null); setUploadMode('url'); load(); }
      else toast.error(data.message);
    } catch { toast.error('Error'); }
    setLoading(false);
  };

  const remove = async (id) => {
    if (!window.confirm('Delete?')) return;
    const token = localStorage.getItem('token');
    await fetch(API + '/news/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    toast.success('Deleted!'); load();
  };

  const toggleActive = async (feed) => {
    const token = localStorage.getItem('token');
    await fetch(API + '/news/' + feed.id, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ ...feed, is_active: !feed.is_active }) });
    load();
  };

  const s = {
    page: { padding: 24, background: '#f8fafc', minHeight: '100vh' },
    title: { fontSize: 22, fontWeight: 900, color: '#1e293b', marginBottom: 6 },
    sub: { color: '#64748b', fontSize: 14, marginBottom: 24 },
    card: { background: '#fff', borderRadius: 16, padding: 24, marginBottom: 24, boxShadow: '0 2px 8px #0001' },
    cardTitle: { fontSize: 16, fontWeight: 800, color: '#1e293b', marginBottom: 16 },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 },
    fieldGroup: { display: 'flex', flexDirection: 'column', gap: 4 },
    label: { fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', marginBottom: 4 },
    input: { border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 13, width: '100%' },
    saveBtn: { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 24px', fontWeight: 700, cursor: 'pointer', fontSize: 13 },
    cancelBtn: { background: '#94a3b8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontWeight: 700, cursor: 'pointer', fontSize: 13, marginLeft: 8 },
    feedGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 },
    feedCard: { background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px #0001', border: '1px solid #f1f5f9' },
    feedImg: { width: '100%', height: 140, objectFit: 'cover', background: '#f1f5f9' },
    feedBody: { padding: 12 },
    feedTitle: { fontSize: 13, fontWeight: 700, color: '#1e293b', marginBottom: 4 },
    feedActions: { display: 'flex', gap: 8, marginTop: 10 },
    modeBtn: { padding: '7px 18px', border: '1px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, background: '#fff' },
    modeBtnActive: { background: '#dc2626', color: '#fff', border: '1px solid #dc2626' },
    uploadBox: { border: '2px dashed #e2e8f0', borderRadius: 12, padding: 32, textAlign: 'center', cursor: 'pointer', background: '#f8fafc', marginBottom: 12 },
  };

  return (
    <div style={s.page}>
      <div style={s.title}>News Feed</div>
      <div style={s.sub}>Manage news feed shown in the mobile app home screen</div>
      <div style={s.card}>
        <div style={s.cardTitle}>{editing ? 'Edit News Feed' : 'Add News Feed'}</div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <button style={{ ...s.modeBtn, ...(uploadMode === 'url' ? s.modeBtnActive : {}) }} onClick={() => setUploadMode('url')}>Image URL</button>
          <button style={{ ...s.modeBtn, ...(uploadMode === 'upload' ? s.modeBtnActive : {}) }} onClick={() => setUploadMode('upload')}>Upload Image</button>
        </div>
        {uploadMode === 'url' ? (
          <div style={{ marginBottom: 12 }}>
            <label style={s.label}>Image URL</label>
            <input style={s.input} value={form.image_url.startsWith('data:') ? '' : form.image_url} onChange={e => setForm(f => ({ ...f, image_url: e.target.value }))} placeholder="https://example.com/image.jpg" />
          </div>
        ) : (
          <div style={s.uploadBox} onClick={() => fileRef.current.click()}>
            <div style={{ fontSize: 40 }}>📷</div>
            <div style={{ fontSize: 14, color: '#64748b', marginTop: 8, fontWeight: 600 }}>Click to select image (max 5MB)</div>
            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileUpload} />
          </div>
        )}
        {form.image_url && <img src={form.image_url} alt="preview" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, marginBottom: 12 }} onError={e => e.target.style.display='none'} />}
        <div style={s.grid}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Title (optional)</label>
            <input style={s.input} value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} placeholder="News title..." />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Sort Order</label>
            <input style={s.input} type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order: parseInt(e.target.value) || 0 }))} />
          </div>
          <div style={{ ...s.fieldGroup, gridColumn: '1/-1' }}>
            <label style={s.label}>Link URL (optional)</label>
            <input style={s.input} value={form.link_url} onChange={e => setForm(f => ({ ...f, link_url: e.target.value }))} placeholder="https://..." />
          </div>
        </div>
        <button style={s.saveBtn} onClick={save} disabled={loading || !form.image_url}>{loading ? 'Saving...' : editing ? 'Update' : 'Add'}</button>
        {editing && <button style={s.cancelBtn} onClick={() => { setEditing(null); setForm({ title: '', image_url: '', link_url: '', sort_order: 0 }); setUploadMode('url'); }}>Cancel</button>}
      </div>
      <div style={s.card}>
        <div style={s.cardTitle}>News Feed List ({feeds.length})</div>
        {feeds.length === 0 ? <div style={{ textAlign: 'center', color: '#94a3b8', padding: 40 }}>No news feeds yet.</div> : (
          <div style={s.feedGrid}>
            {feeds.map(feed => (
              <div key={feed.id} style={{ ...s.feedCard, opacity: feed.is_active ? 1 : 0.6 }}>
                {feed.image_url ? <img src={feed.image_url} alt={feed.title} style={s.feedImg} onError={e => e.target.style.display='none'} /> : <div style={{ ...s.feedImg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>No Image</div>}
                <div style={s.feedBody}>
                  <div style={s.feedTitle}>{feed.title || '(No title)'}</div>
                  <div style={{ fontSize: 11, color: '#94a3b8' }}>Order: {feed.sort_order} | {feed.is_active ? 'Active' : 'Hidden'}</div>
                  <div style={s.feedActions}>
                    <button style={{ flex:1, background:'#f97316', color:'#fff', border:'none', borderRadius:6, padding:'6px 0', fontWeight:700, cursor:'pointer', fontSize:12 }} onClick={() => { setEditing(feed.id); setForm({ title: feed.title||'', image_url: feed.image_url||'', link_url: feed.link_url||'', sort_order: feed.sort_order }); setUploadMode(feed.image_url?.startsWith('data:') ? 'upload' : 'url'); }}>Edit</button>
                    <button style={{ flex:1, border:'none', borderRadius:6, padding:'6px 0', fontWeight:700, cursor:'pointer', fontSize:12, background: feed.is_active ? '#fef3c7' : '#dcfce7', color: feed.is_active ? '#f59e0b' : '#10b981' }} onClick={() => toggleActive(feed)}>{feed.is_active ? 'Hide' : 'Show'}</button>
                    <button style={{ flex:1, background:'#fee2e2', color:'#dc2626', border:'none', borderRadius:6, padding:'6px 0', fontWeight:700, cursor:'pointer', fontSize:12 }} onClick={() => remove(feed.id)}>Delete</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
